export const GET_JOBS = (type) => `/v2/opportunities?type=${type}`;
export const GET_BY_JOB = (id) => `/v2/opportunities/${id}`;
export const UP_DATE = (id) => `/v2/opportunities/${id}`;
export const CREATE_JOB = `/v2/opportunities`;
export const CAMPAIGNS = `/v2/campaigns`;
export const EDIT_CAMPAIGNS = (id) => `/v2/campaigns/${id}`;
export const EVENT = `/v2/ngo-events`;
export const UPDATE_EVENT = (id) => `/v2/ngo-events/${id}`;
export const MEETING = `/v2/meeting-minutes`;
export const UP_DATE_MEETING = (id) => `/v2/meeting-minutes/${id}`;
export const STATISTICS = `/v2/statistics`;
export const UPDATE_STATISTICS = (id) => `/v2/statistics/${id}`;
export const DONORS = (id) => `/v2/donors/${id}`;
export const POST_DONORS = `/v2/donors`;
export const NEWS = `/v2/news`;
export const DETAILSNEWS = (id) => `/v2/news/${id}`;
export const MESSAGES = `v2/contact-us`;
export const METHOD_BY_ID = (id) => `v2/payment-methods/${id}`;
export const METHODS = `v2/payment-methods`;
export const ABOUT_CONTENT = `v2/ngo-about`;
export const ABOUT_CONTENT_UPDATE = `v2/ngo-about`;
